import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import ItemDisplayPromoCodeWrapper from 'dibs-display-promo-code/exports/ItemDisplayPromoCodeWrapper';
import styles from './styles/CartItemPromoCode.scss';

const CartItemPromoCode = ({ user, item, relay }) => {
    return (
        <div className={styles.text}>
            <ItemDisplayPromoCodeWrapper user={user} item={item} environment={relay.environment} />
        </div>
    );
};

CartItemPromoCode.propTypes = {
    relay: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(CartItemPromoCode, {
    item: graphql`
        fragment CartItemPromoCode_item on Item {
            serviceId
            ...ItemDisplayPromoCodeWrapper_item
        }
    `,
    user: graphql`
        fragment CartItemPromoCode_user on User {
            serviceId
            ...ItemDisplayPromoCodeWrapper_user
        }
    `,
});
